import api from "./api";
import {
  ListSystemRolesResponse,
  SaveSystemRolePayload,
  SystemRole,
} from "../types/SystemRole";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findAllRoles(
  currentPage: number,
  perPage: number,
  switchRule?: number,
): Promise<ListSystemRolesResponse> {
  const response = await api.get<ListSystemRolesResponse>("/roles", {
    params: {
      page: currentPage,
      per_page: perPage,
      switch_rule: switchRule,
    },
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function findRole(roleId: string | number): Promise<SystemRole> {
  const response = await api.get<SystemRole>(`/roles/${roleId}`, {
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function createRole(payload: SaveSystemRolePayload): Promise<void> {
  await api.post("/roles", payload, {
    headers: getAuthHeaders(),
  });
}

export async function updateRole(
  roleId: string | number,
  payload: SaveSystemRolePayload,
): Promise<void> {
  await api.put(`/roles/${roleId}`, payload, {
    headers: getAuthHeaders(),
  });
}

export async function deleteRole(roleId: string | number): Promise<void> {
  await api.delete(`/roles/${roleId}`, {
    headers: getAuthHeaders(),
  });
}
